/**
 * Client-side hints for ingest file upload errors (mirrors server classification).
 */

const HINTS_BY_CATEGORY = {
  object_too_large:
    'File size: this file exceeds your Supabase Storage per-object size limit. Use a smaller file or raise the limit in Supabase Dashboard → Storage.',
  storage_auth:
    'Storage authentication failed. Verify SUPABASE_SERVICE_ROLE_KEY on the node server.',
  bucket:
    'Storage bucket missing. Create files_<horizon> in Supabase Storage.',
  storage_other:
    'If other files uploaded successfully, credentials and bucket access are likely fine — use the error code and message above.',
  drive:
    'Google Drive could not supply this file (permissions, export limits, or deleted file).',
};

function classifyFromErrorText(text) {
  const lower = String(text || '').toLowerCase();
  if (/exceeded the maximum allowed size|object too large|entitytoolarge|payload too large|file too large|\[storage_object_too_large\]/i.test(text)) {
    return 'object_too_large';
  }
  if (/rls|row-level security|jwt|unauthorized|forbidden|invalid.*key|service.role|\[storage_auth\]/i.test(lower)) {
    return 'storage_auth';
  }
  if (/bucket.*not found|bucket not found|\[storage_bucket_not_found\]/i.test(lower)) {
    return 'bucket';
  }
  if (/upload to storage failed|\[storage_error\]|upload failed/i.test(lower)) {
    return 'storage_other';
  }
  if (/drive|google|oauth/i.test(lower)) {
    return 'drive';
  }
  return null;
}

function hintForFileError(entry) {
  if (entry?.hint) return entry.hint;
  const category = entry?.errorCategory || classifyFromErrorText(entry?.error || entry?.message);
  return category ? HINTS_BY_CATEGORY[category] || null : null;
}

function collectFileErrorHints(errors) {
  const hints = new Set();
  for (const e of errors || []) {
    const hint = hintForFileError(e);
    if (hint) hints.add(hint);
  }
  return [...hints];
}

function shouldShowLegacyStorageKeyHint(errors) {
  return (errors || []).some((e) => {
    const category = e?.errorCategory || classifyFromErrorText(e?.error || e?.message);
    return category === 'storage_auth' || category === 'bucket';
  });
}

export {
  classifyFromErrorText,
  hintForFileError,
  collectFileErrorHints,
  shouldShowLegacyStorageKeyHint,
};
